"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationWrapperComponent = void 0;
const animations_1 = require("@angular/animations");
const core_1 = require("@angular/core");
let AnimationWrapperComponent = class AnimationWrapperComponent {
    constructor() {
        this.isVisible = false;
    }
    ngOnInit() {
        this.isVisible = true;
    }
};
AnimationWrapperComponent = __decorate([
    (0, core_1.Component)({
        selector: 'animation-wrapper',
        template: `
    <div *ngIf="isVisible" [@fadeInOut]>
      <ng-content></ng-content>
    </div>
  `,
        animations: [(0, animations_1.trigger)('fadeInOut', [
                (0, animations_1.transition)(':enter', [
                    (0, animations_1.style)({ opacity: 0, transform: 'scale(0.8)' }),
                    (0, animations_1.animate)('300ms ease', (0, animations_1.style)({ opacity: 1, transform: 'scale(1)' })), // Final style
                ]),
                (0, animations_1.transition)(':leave', [
                    (0, animations_1.animate)('300ms ease', (0, animations_1.style)({ opacity: 0, transform: 'scale(0.8)' })), // Animation when leaving
                ]),
            ])],
    })
], AnimationWrapperComponent);
exports.AnimationWrapperComponent = AnimationWrapperComponent;
